export default __webpack_public_path__ + "static/media/neftify_logo.8395ba46.png";